import { Component, OnInit } from '@angular/core';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { CheckBoxFormControl } from './checkbox.control';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-checkbox-control',
  templateUrl: './bs-app-launch-checkbox-control.component.html',
  styleUrls: ['./bs-app-launch-checkbox-control.component.scss']
})
export class BsAppLaunchCheckboxControlComponent extends BsAppLaunchFormControlBaseComponent<CheckBoxFormControl> implements OnInit {
  formControl: CheckBoxFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit() {
    // Track initial value
    this.formControl.trackValueForFormUpdates();

    this.subs.sink = this.formControl.valueChanges.subscribe(() => {
      this.toggle();

      // Check if value changed and emit
      this.checkAndFireFormUpdate();
      // Update tracked value after emitting
      this.formControl.trackValueForFormUpdates();
    });
  }

  updatedSelectedChoices(index: number, checked: boolean): void {
    // Re-snapshot the value before mutating it. Do not remove this line.
    //
    // Why this is needed here but NOT in the radio/select controls:
    // Radio and select bind a single reactive control via [formControl] and have a single
    // (focus)="onFocus()" handler on that element. onFocus() (in the base component) calls
    // trackValueForFormUpdates(), so previousValue is always re-synced right before any user
    // change. The checkbox is structurally different: it does NOT use [formControl]. Each
    // rad-checkbox is independent, the value array is assembled manually here, and there is no
    // single focus event that fires before a value change for the control as a whole. So the
    // checkbox cannot rely on onFocus() to keep previousValue in sync.
    //
    // This matters because a prior server callback may have set the value via
    // setValue(..., { emitEvent: false }) (see handleValueUpdate CHECK_BOX case in
    // bs-app-launch-form-control.ts). A silent update does not run the valueChanges subscription,
    // so previousValue is left stale. Re-snapshotting here resyncs it before we diff. Without it,
    // checkAndFireFormUpdate diffs against stale state and can spuriously fire or, worse, suppress
    // a legitimate form-update trigger (a missed toggler/callback cascade).
    this.formControl.trackValueForFormUpdates();
    this.formControl.choices[index].checked = checked;

    const updatedSelectedValues = this.formControl.choices
      .filter((choice) => !!choice.checked)
      .map((choice) => choice.value);

    this.formControl.setValue(updatedSelectedValues);
  }

}
